﻿<template>
        <!--TEMPORARY MESSAGE DURING PAYMENT FAILURES-->
    <div v-if="!isAgent_Login() && GetBrand() == 'HEX'" class="cart-addon" >
        <p class="m-auto font-bold text-black pt-2 text-center">If you don't receive a confirmation email please contact us at info@highlandexplorertours.com</p>
    </div>
    <div v-if="!isAgent_Login() && GetBrand() == 'HAG'" class="cart-addon" >
        <p class="m-auto font-bold text-black pt-2 text-center">If you don't receive a confirmation email please contact us at info@haggisadventures.com</p>
    </div>
    
    <div class="pax-details mt-12">
        <h6 class="ml-2">Add Passenger Information</h6>

        <form class="border border-grey-lightest rounded mt-8" @submit.prevent="Prevent_Submit()" v-for="(passenger, index) in get_Booking().passengers">

            <fieldset class="relative">
                <passenger :checkPassengers="checkPassengers" :passenger=passenger :index=index></passenger>
            </fieldset>

        </form>
        <button v-if="get_Booking().passengers.length > 1" @click="scrollToTop()" class="float-centre button button-standard xsmall rounded mr-6 mb-6 mt-4 ml-4" >
            <svg class="inline -mt-1 mr-1 w-4 svg-inline--fa fa-arrow-up fa-w-18 fa-2x" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="arrow-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M34.9 289.5c-9.4-9.4-9.4-24.6 0-33.9l184-184c9.4-9.4 24.6-9.4 33.9 0l184 184c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L248 153.9V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V153.9L68.7 289.5c-9.4 9.4-24.6 9.4-33.8 0z" class=""></path></svg>
            Jump to top
        </button>

    </div>
</template>

<script lang="ts" src="./passengers.ts"></script>